@use '@ingka/variables/style.scss' as *;

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.list {
  & > li {
    opacity: 0;
    animation-name: fadeIn;
    animation-duration: 1200ms;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
  }

  & > li:nth-child(1) {
    animation-delay: 0ms;
  }
  & > li:nth-child(2) {
    animation-delay: 30ms;
  }
  & > li:nth-child(3) {
    animation-delay: 60ms;
  }
  & > li:nth-child(4) {
    animation-delay: 90ms;
  }

  @media (prefers-reduced-motion: reduce) {
    & > li {
      animation-name: none;
      opacity: 1;
    }
  }
}
